import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { ENABLE_AUTHENTICATION_STEPS } from "shared";

import { TitleProps } from "../types";

const Title = ({ step }: TitleProps) => {
    const { gray900 } = colors;

    const { t } = useTranslation();

    const renderText = () => {
        switch (step) {
            case ENABLE_AUTHENTICATION_STEPS.GetSecretKey:
            case ENABLE_AUTHENTICATION_STEPS.SendOtpCode:
                return t("Security##2FA##title##authentication app");
            case ENABLE_AUTHENTICATION_STEPS.GetEmailCode:
            case ENABLE_AUTHENTICATION_STEPS.SendEmailCode:
                return t("Security##2FA##title##authentication email");
            case ENABLE_AUTHENTICATION_STEPS.RecoveryCodes:
                return t("Security##recovery codes##second step title");
            case ENABLE_AUTHENTICATION_STEPS.SuccessMessage:
                return t("Security##2FA##title##is enabled");
            default:
                return t("Security##2FA##title##protect your account");
        }
    };

    return (
        <div
            css={css({
                color: gray900,
                fontSize: "20px",
                fontWeight: "500",
                lineHeight: "24px",
                letterSpacing: "0.15px",
                marginTop: "8px"
            })}
        >
            {renderText()}
        </div>
    );
};

export { Title };
